module.exports = __webpack_public_path__ + "img/图1.bd8fcbfd.png";